<script>
  import { link, navigate } from 'svelte-routing';
  import { fade } from 'svelte/transition';
  import { getCategoryDisplayName } from '../../../common/utils';
  import { categories } from '../../../Store/store';

  export let channel = null;

  const onChannelClicked = () => {
    navigate(`/chat/${channel.id}`);
  };
</script>

<div class="channel-container" in:fade on:click={onChannelClicked}>
  <div class="header">
    <div class="type">
      {getCategoryDisplayName($categories, channel?.category)}
    </div>
    <div class="indicator" class:live={channel?.live} class:video={channel?.roomId}>
      {#if channel.roomId}
        <span class="material-icons" in:fade> videocam </span>
      {/if}
      <p>{channel?.live ? 'Live nå' : 'Ferdig chat'}</p>
    </div>
  </div>
  <h1>{channel.name}</h1>
</div>

<style src="./channel.scss"></style>
